import styled from '@emotion/styled';
import { rgba } from 'polished';
import React from 'react';
import { device } from '../../styles/devices';

export interface TableProps {
  children?: React.ReactNode;
  isZebra?: boolean;
  isClickable?: boolean;
  isSelectable?: boolean;
  colorTheme?: 'primary' | 'secondary' | 'ternary';
  compact?: boolean;
}

const Host = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
`;

const TableHost = styled.table<TableProps>`
  width: 100%;
  text-align: right;
  border-collapse: separate;

  th {
    &:first-child {
      text-align: left;
      ${(props) => !props.isZebra && `padding-left: 0px;`}

      @media ${device.tablet} {
        ${(props) =>
          !props.isZebra && !props.isSelectable
            ? `padding-left: 0px;`
            : `padding-left: 10px;`}
      }
    }
    &:last-child {
      text-align: right;
      ${(props) => !props.isZebra && `padding-right: 0px;`}

      @media ${device.tablet} {
        ${(props) =>
          !props.isZebra && !props.isSelectable
            ? `padding-right: 0px;`
            : `padding-right: 10px;`}
      }
    }
  }

  td {
    z-index: 2;

    &:after {
      content: '';

      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;

      height: 2px;
      width: 100%;

      transition: background-color 100ms ease-in;
    }
    position: relative;
    ${(props) => (props.compact ? 'padding: 8px 0' : undefined)};
    transition: border-color 100ms ease-in;
    border-bottom: 1px solid ${(props) => rgba(props.theme.colors.primary, 0.1)};
    padding-bottom: ${(props) => (props.compact ? '12px;' : '8px')};

    &:first-child {
      text-align: left;
      ${(props) => !props.isZebra && `padding-left: 0px;`}

      @media ${device.tablet} {
        ${(props) =>
          !props.isZebra && !props.isSelectable
            ? `padding-left: 0px;`
            : `padding-left: 11px;`}
      }
    }

    &:last-child {
      text-align: right;
      ${(props) => !props.isZebra && `padding-right: 0px;`}

      @media ${device.tablet} {
        ${(props) =>
          !props.isZebra && !props.isSelectable
            ? `padding-right: 0px;`
            : `padding-right: 11px;`}
      }
    }
  }

  tr:nth-child(2n) {
    td {
      ${(props) => {
        if (props.isZebra)
          return `
          background-color: ${props.theme.shades[`${props.colorTheme}1`]};
        `;
      }}
    }
  }

  tr:hover td {
    ${(props) => {
      if (props.isClickable && props.colorTheme !== undefined)
        return `
        z-index: 2;
        position:relative;
        cursor: pointer;
        padding-bottom:${props.compact ? '11px' : '7px'};
        border-bottom: 2px solid ${
          props.colorTheme !== 'primary'
            ? props.theme.shades[`${props.colorTheme}3`]
            : '#cadbf0'
        };            
      `;
    }}
  }
`;

export const Table = ({
  children,
  isZebra = false,
  isClickable = false,
  isSelectable = false,
  colorTheme = 'primary',
  ...rest
}: TableProps) => {
  return (
    <Host>
      <TableHost
        isZebra={isZebra}
        isClickable={isClickable}
        isSelectable={isSelectable}
        colorTheme={colorTheme}
        {...rest}
      >
        {children}
      </TableHost>
    </Host>
  );
};
